'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import DocumentTitle from '@uw-it-sis/lib-react/lib/DocumentTitle';

import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";

import importSocialPlanConfirmStore from './ImportSocialPlanConfirmStore';

/*
 * This component handles the social plan import confirm page, including the
 * "no data found" page.
 *
 * This component is separate from the main import component because the social
 * user data won't be available to load until the user hits the import/confirm
 * page.
 */
class ImportSocialPlanConfirm extends Component {
    constructor(props) {
        super(props);
        this.store = importSocialPlanConfirmStore;
        this.buildDoneComponent = this.buildDoneComponent.bind(this);
    }

    componentDidMount() {
        this.store.mount()
    }

    buildDoneComponent() {
        let component;

        if (this.store.social.hasData) {
            component =
                <DocumentTitle title="Confirm Plan Import - MyPlan">
                    <>
                        <div className="page-heading">
                            <h1>Confirm your import here</h1>
                        </div>
                        <div>
                            <p>
                                Importing these planned courses, placeholders, backup and bookmarked courses from your {this.store.social.provider} account will
                                overwrite the contents of your current plan.
                            </p>
                            <p>
                                Do you want to import the plan from {this.store.social.provider} account <strong>{this.store.social.email}</strong>?
                            </p>
                        </div>
                        <ButtonToolbar>
                            <Button variant="primary" onClick={this.store.runImport}>Import</Button>
                            <Button variant="secondary" href="/plan">Cancel</Button>
                        </ButtonToolbar>
                    </>
                </DocumentTitle>;
        } else if (! this.store.social.email) {
            // No account was found... maybe the user skipped the social login
            // filter by typing in the url to get here or the session ended or
            // something.
            component =
                <DocumentTitle title="No Import Account Found - MyPlan">
                    <>
                        <div className="page-heading">
                            <h1>No Social Account Found</h1>
                        </div>
                        <div>
                            <p>
                                MyPlan couldn't find a social account to import from. You may want to go back and try logging in again.
                            </p>
                        </div>
                        <ButtonToolbar>
                            <Button variant="primary" href="/plan/#/import">Back</Button>
                            <Button variant="secondary" href="/plan">Cancel</Button>
                        </ButtonToolbar>
                    </>
                </DocumentTitle>;
        } else {
                component =
                    <DocumentTitle title="No Items to Import - MyPlan">
                        <>
                            <div className="page-heading">
                                <h1>No items to import</h1>
                            </div>
                            <div>
                                <p>
                                    MyPlan couldn't find any items associated with {this.store.social.provider} account <strong>{this.store.social.email}</strong>. You may want to sign out of your {this.store.social.provider} account and choose a different account.
                                </p>
                            </div>
                            <ButtonToolbar>
                                <Button variant="primary" href="/plan/#/import">Back</Button>
                                <Button variant="secondary" href="/plan">Cancel</Button>
                            </ButtonToolbar>
                        </>
                    </DocumentTitle>;
        }

        return component;

    }

    render() {
        return (
            <DocumentTitle title={`${appStore.getDisplayName()} - MyPlan`}>
                <SimpleState state={this.store.state}
                             doneComponentBuilder={this.buildDoneComponent}
                             pendingComponentBuilder="dots"
                             name="Import" />
            </DocumentTitle>
        );
    }
}

export default observer(ImportSocialPlanConfirm);
